import type { ToolkitCollection } from "@/clients/arcade/arcade";

export const HIDDEN_TOOLKITS = new Set<string>([
  "google",
  "microsoft",
  "search",
  "web",
  "codesandbox",
  "outlookcalendar",
  "outlookmail",
  "sharepoint",
]);

/**
 * Filters hidden toolkits and their tools from a ToolkitCollection.
 * Names in `hiddenSet` must be lowercase.
 */
export function filterHiddenToolkits(
  collection: ToolkitCollection,
  hiddenSet: Set<string>
): ToolkitCollection {
  if (hiddenSet.size === 0) {
    return collection;
  }

  const isHidden = (name: string) => hiddenSet.has(name.toLowerCase());

  const filteredToolkitMap = new Map(
    Array.from(collection.toolkitMap.entries()).filter(
      ([name]) => !isHidden(name)
    )
  );

  const filteredTools = collection.tools.filter(
    (tool) => !isHidden(tool.toolkit.name)
  );

  const filteredToolkits = collection.toolkits.filter(
    (tk) => !isHidden(tk.name)
  );

  return {
    ...collection,
    toolkitMap: filteredToolkitMap,
    tools: filteredTools,
    toolkits: filteredToolkits,
  };
}
